<template>
    <a-card :bordered="false">
      <!-- 查询区域 -->
      <div class="table-page-search-wrapper">
        <a-form layout="inline" @keyup.enter.native="searchQuery" :model="queryParam" >
          <a-row :gutter="24">
          <a-col :xl="6" :lg="7" :md="8" :sm="24">
            <a-form-item :label="this.language['cs.person.personid']"> 
              
             <a-input maxLength="50"  v-model="queryParam.personid" :placeholder="this.language['cs.person.personid']"></a-input>
            </a-form-item>
          </a-col>
          <a-col :xl="6" :lg="7" :md="8" :sm="24">
            <a-form-item :label="this.language['cs.person.pname']"> 
              
             <a-input maxLength="50"  v-model="queryParam.pname" :placeholder="this.language['cs.person.pname']"></a-input>
            </a-form-item>
          </a-col>
          <a-col :xl="6" :lg="7" :md="8" :sm="24">
            <a-form-item :label="this.language['cs.person.jobname']">
             <a-input maxLength="50"  v-model="queryParam.jobname" :placeholder="this.language['cs.person.jobname']"></a-input>
            </a-form-item>
          </a-col>
          <a-col :xl="6" :lg="7" :md="8" :sm="24">
            <a-form-item :label="this.language['cs.person.deptname']">
             <a-input maxLength="50"  v-model="queryParam.deptname" :placeholder="this.language['cs.person.deptname']"></a-input>
            </a-form-item>
          </a-col>
          <a-col :xl="6" :lg="7" :md="8" :sm="24" v-show="isShow">
            <a-form-item :label="this.language['cs.activity.activityname']">
              <a-Select  v-model="queryParam.sysactivityid" :options="selectActivityList" allow-clear  show-search optionFilterProp="children" 
               :placeholder="this.language['cs.activity.activityname']"  >
              </a-Select></a-form-item>
          </a-col>
          <a-col :xl="6" :lg="7" :md="8" :sm="24" v-show="isShow">
            <a-form-item :label="this.language['cs.venue.venuename']">
              <a-Select  v-model="queryParam.sysvenueid"  :options="selectVenueList" allow-clear  show-search optionFilterProp="children" 
               :placeholder="this.language['cs.venue.venuename']"  >
              </a-Select></a-form-item>
          </a-col>

          <a-col :xl="6" :lg="7" :md="8" :sm="24">
            <a-form-item :label="this.language['cs.seatgroup.sgroupname']">
              <a-Select  mode="multiple" v-model="queryParam.syspgidlist"  :options="selectPgList" allow-clear  show-search optionFilterProp="children" 
               :placeholder="this.language['cs.seatgroup.sgroupname']"  >
              </a-Select></a-form-item>
          </a-col>
          <a-col :xl="6" :lg="7" :md="8" :sm="24">
            <a-form-item :label="this.language['cs.person.seatstatus']">
              <a-Select  mode="multiple" v-model="queryParam.isseat"  :options="isSeatList" allow-clear  show-search optionFilterProp="children" 
               :placeholder="this.language['cs.person.seatstatus']"  >
              </a-Select>
            </a-form-item>
          </a-col>

     
            <a-col :xl="6" :lg="7" :md="8" :sm="24">
              <span style="float: left;overflow: hidden;" class="table-page-search-submitButtons">
                <a-button type="primary" @click="searchQuery" icon="search">{{this.language['common.searchButton']}}</a-button>
                <a-button type="primary" @click="searchReset" icon="reload" style="margin-left: 8px">{{this.language['common.resetButton']}}</a-button>
              </span>
            </a-col>
          </a-row>
        </a-form>
      </div>
      <!-- 查询区域-END -->
      
      <!-- 操作按钮区域 -->
      <div class="table-operator">
        <a-button @click="handleAdd" type="primary" icon="plus" v-has="'personinfo:add'">{{this.language['common.insertButton']}}</a-button>
        <a-button type="primary" icon="import" @click="handleImportXls">{{this.language['common.importButton']}}</a-button>
        <a-button type="primary" icon="download" @click="handleExport">{{this.language['common.exportButton']}}</a-button>
    
        <!-- 高级查询区域 -->
        <a-dropdown v-if="selectedRowKeys.length > 0">
          <a-menu slot="overlay">
            <a-menu-item key="1" @click="batchDel" v-has="'personinfo:deletebatch'"><a-icon type="delete"/>{{this.language['common.delete']}}</a-menu-item>
            <a-menu-item key="1" @click="batchEditPg" v-has="'personinfo:deletebatch'"><a-icon type="edit"/>{{this.language['cs.edit.persongroup']}}</a-menu-item>
          </a-menu>
          <a-button style="margin-left: 8px"> 批量操作 <a-icon type="down" /></a-button>
        </a-dropdown>
      </div>
  
      <!-- table区域-begin -->
      <div>
        <div class="ant-alert ant-alert-info" style="margin-bottom: 16px;">
          <i class="anticon anticon-info-circle ant-alert-icon"></i> 已选择 <a style="font-weight: 600">{{ selectedRowKeys.length }}</a>项
          <a style="margin-left: 24px" @click="onClearSelected">清空</a>
        </div>
  
        <a-table
          ref="table"
          size="middle"
          bordered
          rowKey="sysid"
          class="j-table-force-nowrap"
          :scroll="{x:1800}"
          :dataSource="dataSource"
          :pagination="ipagination"
          :columns="columns"
          :loading="loading"
          :rowSelection="{selectedRowKeys: selectedRowKeys, onChange: onSelectChange}"
          @change="handleTableChange">
          <template slot="htmlSlot" slot-scope="text">
            <div v-html="text"></div>
          </template>
          <span slot="action" slot-scope="text, record">
            <a @click="handleEdit(record)" v-has="'personinfo:edit'">{{language['common.edit']}}</a>
  
            <a-divider type="vertical" />
            <a-dropdown>
              <a class="ant-dropdown-link">{{language['common.more']}} <a-icon type="down" /></a>
              <a-menu slot="overlay">
                <a-menu-item>
                  <a @click="handleDetail(record)" v-has="'personinfo:view'">{{language['common.look']}}</a>
                </a-menu-item>
                <a-menu-item v-has="'personinfo:delete'">
                  <a-popconfirm :title="language['common.deleteConfirmInfo']" @confirm="() => handleDelete(record.sysid)">
                    <a>{{language['common.delete']}}</a>
                  </a-popconfirm>
                </a-menu-item>
              </a-menu>
            </a-dropdown>
          </span>
        </a-table>
      </div>
 
      <person-modal ref="modalForm" @ok="modalFormOk"></person-modal>
<!-- 批量修改 -->
<j-modal
    title="批量修改人員分組"
    width="400px"
    :visible="pgvisible"
    @ok="handlePgOk"
    @cancel="handlePgCancel"
    cancelText="关闭">
   <template>
    <a-card :bordered="false">
  
      <div class="table-page-search-wrapper">
    <a-form layout="inline"  :model="editPGForm"  >
      <a-row :gutter="24">
          <a-col :span="24">
                <a-form-item :label="this.language['cs.persongroup.pgroupname']">
                  <a-Select  v-model="editPGForm.syseditpgid" width="200" :options="selectEditPgList" allow-clear  show-search optionFilterProp="children" 
               :placeholder="this.language['cs.persongroup.pgroupname']"  >
              </a-Select>
              </a-form-item>
            </a-col>
          </a-row>
        </a-form>
      </div>
    </a-card>
   </template>
  </j-modal>
  <import-person-modal ref="importModal" :url="getImportUrl()" @ok="importOk"></import-person-modal>
    </a-card>
  </template>
  
  <script>
    import { httpAction, getAction } from '@/api/manageChooseSeat'
    import '@/assets/less/TableExpand.less'
    import { JeecgListMixin } from '@/views/chooseSeat/mixins/JeecgListMixin.js'
    import { getDictItemsFromCache  } from '@/api/api'
    import { exportFileExcel } from '@/api/exportFile'
    import PersonModal from './modules/PersonModal'
    import ImportPersonModal from './modules/ImportPersonModal'
    export default {
      name: "Person",
      mixins:[JeecgListMixin],
      inject:['dataActivity'],
      components: {
        PersonModal,
        ImportPersonModal
        
      },
      data () {
        return {
          description: '人員信息',
          pgvisible:false,
          editPGForm: {},
          // 表头
         
          url: {
            list: "/PersonInfo/list",
            delete: "/PersonInfo/delete",
            deleteBatch: "/PersonInfo/deleteBatch",
            editPGBatch: "/PersonInfo/editPGBatch",
            import: "/PersonInfo/Import"
            
          },
          selectActivityList:[],
          selectPgList:[],
          selectVenueList:[],
          selectEditPgList:[],
          disableMixinCreated: true,
          isShow:true,
          isSeatList:[{label:"Y",value:"Y"},{label:"N",value:"N"}],
          operation :{   
            visible: true,
            optiontype:"add",   
           }, 
        }
      },
      created() {
        this.loadSelectData();
        this.loadData(1);
      },
      
      provide(){
        return{
         operation:this.operation
        }
       },
      mounted(){
      
      },
      watch:{
        'queryParam.sysactivityid':function (val) {
                if (val) {
                  this.selectPgList=[];
                  let selectparams = { keytype: "sgroup", parentid:val};   
                    getAction('/SelectData/SelectDataList', selectparams).then((res) => {
                      if (res.success) {
                        this.selectPgList= res.result.records;
                      }
                  }); 
                } 
                else {
                  this.selectPgList=[];
                }
              }

      },
      computed: {
        language() {
          return this.$store.getters.language
        },
        columns() {
          if (this.language) {
            return  [
            {
              title: '#',
              dataIndex: '',
              key:'rowIndex',
              width:60,
              align:"center",
              customRender:function (t,r,index) {
                return parseInt(index)+1;
              }
            },
            {
              title: this.language['cs.person.personid'],
              align:"left",
              width:150,
              ellipsis: true,
              dataIndex: 'personid'
            },
            {
              title:this.language['cs.person.pname'],
              align:"left",
              width:150,
              ellipsis: true,
              dataIndex: 'pname'
            },
            {
              title:this.language['cs.person.sex'],
              align:"left",
              width:150,
              ellipsis: true,
              dataIndex: 'sexname'
            },
            {
              title:this.language['cs.person.jobname'],
              align:"left",
              width:150,
              ellipsis: true,
              dataIndex: 'jobname'
            }, 
            {
              title:this.language['cs.person.deptname'],
              align:"left",
              width:150,
              ellipsis: true,
              dataIndex: 'deptname'
            }, 
             {
              title:this.language['cs.person.phone'],
              align:"left",
              width:150,
              ellipsis: true,
              dataIndex: 'phone'
            }, 
            {
              title:this.language['cs.person.email'],
              align:"left",
              width:150,
              ellipsis: true,
              dataIndex: 'email'
            }, 
            {
              title:this.language['cs.person.workno'],
              align:"left",
              width:150,
              ellipsis: true,
              dataIndex: 'workno'
            }, 
            {
              title:this.language['cs.person.sourcedesc'],
              align:"left",
              width:150,
              ellipsis: true,
              dataIndex: 'sourcedesc'
            }, 
            {
              title:this.language['cs.activity.activityname'],
              align:"left",
              width:150,
              ellipsis: true,
              dataIndex: 'activityname'
            }, 
           
            {
              title:this.language['cs.seatgroup.sgroupname'],
              align:"left",
              width:150,
              ellipsis: true,
              dataIndex: 'sgroupname'
            },  
            {
              title:this.language['cs.venue.venuename'],
              align:"left",
              width:150,
              ellipsis: true,
              dataIndex: 'venuename'
            },  
             {
              title:this.language['cs.person.seatstatus'],
              align:"center",
              width:150,
              ellipsis: true,
              dataIndex: 'isseat'
            }, 
            {
              title:this.language['cs.person.seatinfo'],
              align:"left",
              width:150,
              ellipsis: true,
              dataIndex: 'seatno'
            }, 
            {
              title:this.language['common.creator'],
              align:"center",
              width:150,
              ellipsis: true,
              dataIndex: 'creator'
            },  
            {
              title:this.language['common.createTime'],
              align:"center",
              width:150,
              ellipsis: true,
              dataIndex: 'createdate'
            },  
            {
              title:this.language['common.modifier'],
              align:"center",
              width:150,
              ellipsis: true,
              dataIndex: 'modifier'
            },  
            {
              title:this.language['common.modifyTime'],
              align:"center",
              width:150,
              ellipsis: true,
              dataIndex: 'modifydate'
            },  
            {
              title: '操作',
              dataIndex: 'action',
              align:"center",
              fixed:"right",
              width:147,
              scopedSlots: { customRender: 'action' },
            }
          ]
          }
        }
      },
      methods: {
        loadSelectData() { 
          this.selectActivityList=null;  
          this.selectPgList=null; 
          this.selectVenueList =null; 
          let selectactivity= { keytype: "activity", parentid:""};  
           getAction('/SelectData/SelectDataList', selectactivity).then((res) => {
          if (res.success) {
            this.selectActivityList= res.result.records;
          }
            });  
            let selectvenue= { keytype: "venue", parentid:""};  
           getAction('/SelectData/SelectDataList', selectvenue).then((res) => {
          if (res.success) {
            this.selectVenueList= res.result.records;
          }
        });  
        if(this.dataActivity!=null)
        {
        this.queryParam.sysactivityid=this.dataActivity.sysactivityid;
        this.queryParam.sysvenueid=this.dataActivity.sysvenueid;
        this.isShow=this.dataActivity.isShow;
        this.selectPgList=[];
         let selectparams = { keytype: "sgroup", parentid:this.dataActivity.sysactivityid};   
          getAction('/SelectData/SelectDataList', selectparams).then((res) => {
                      if (res.success) {
                        this.selectPgList= res.result.records;
                      }
                  });  
        }
            
      },
      batchEditPg(){
        var sysactivityid="";
        if (this.selectedRowKeys.length < 1) {
        this.$message.warning('请选择一条记录！');
        return;
      }
      else {
       
        for (var a = 0; a < this.selectionRows.length; a++) {
          if(a==0)
          {
            sysactivityid=this.selectionRows[0].sysactivityid
          }
         
          if(this.selectionRows[a].sysactivityid!=sysactivityid)
          {

            this.$message.warning('请选择同一個活動人員信息進行批量修改');
            return;
          }
          sysactivityid=this.selectionRows[a].sysactivityid

        }
      }
      this.selectEditPgList=[];
      let selectparams = { keytype: "sgroup", parentid:sysactivityid};   
                    getAction('/SelectData/SelectDataList', selectparams).then((res) => {
                      if (res.success) {
                        this.selectEditPgList= res.result.records;
                      }
                  }); 
                 
                  this.$set( this.editPGForm, 'syseditpgid', '');
        this.pgvisible=true;
      },
      handlePgOk(){
        var ids = ""; 
      //   for (var a = 0; a < this.selectionRows.length; a++) {
      //     ids += this.selectionRows[a].sysid + ",";
      
      // }
      for (var a = 0; a < this.selectedRowKeys.length; a++) {
          ids += this.selectedRowKeys[a] + ",";
        }
      if(this.editPGForm.syseditpgid==null|| ids=="")
      {
        this.$message.warning('請選擇人員分組名稱');
        return;
      }
    
      httpAction(this.url.editPGBatch+"?personids="+ids+"&pgid="+this.editPGForm.syseditpgid, "", "post").then((res) => {
              if (res.success) {
                that.$message.success(res.message);
                that.$emit('ok');
              } else {
                that.$message.warning(res.message);
              }
            }).finally(() => {
              this.reCalculatePage(this.selectedRowKeys.length)
              this.loadData(1);
              this.onClearSelected();
              this.pgvisible=false;
            })
      },
      handlePgCancel(){
        this.pgvisible=false;
      },
      handleExport(){
        let mapObj = {
        personid: this.language['cs.person.personid'],
        pname: this.language['cs.person.pname'],
        jobname: this.language['cs.person.jobname'],
        deptname: this.language['cs.person.deptname'],
        phone:this.language['cs.person.phone'],
        activityname:this.language['cs.activity.activityname'],
        sgroupname:this.language['cs.seatgroup.sgroupname'],
        venuename:this.language['cs.venue.venuename'],
        creator:this.language['common.creator'],
        createdate:this.language['common.createTime'],
        modifier:this.language['common.modifier'],
        modifydate:this.language['common.modifyTime']
      }
      let params = this.getQueryParams() //查询条件
      params.pageSize = 10000
      params.pageNo = 1
      this.loading = true
      getAction(this.url.list, params)
        .then((res) => {
          if (res.success) {
            const result = res.result.records || res.result
            exportFileExcel(res.result.records , mapObj, "personInfo")
          } else {
            this.$message.warning(res.message)
          }
        })
        .finally(() => {
          this.loading = false
        })

      }, 
      handleImportXls(){
        this.$refs.importModal.show()

      },
       handleEdit(record) {
            this.$refs.modalForm.edit(record);
            this.$refs.modalForm.title = "编辑";
            this.$refs.modalForm.disableSubmit = false;
            this.operation.optiontype="edit"; 
            this.operation.visible=true;
           // this.operation.sysactivityid=record.sysactivityid;
          },
         
         handleAdd () {
            this.$refs.modalForm.add();
            this.$refs.modalForm.title = "新增";
            this.$refs.modalForm.disableSubmit = false;
            this.operation.optiontype="add";
            this.operation.visible=false;
         },
      getImportUrl(){
      
        return this.url.import;
      },
    searchQuery() {
        
        this.loadData(1);
        },
        searchReset() {
      this.queryParam = {}
      if(this.dataActivity!=null)
        {
        this.queryParam.sysactivityid=this.dataActivity.sysactivityid;
        this.queryParam.sysvenueid=this.dataActivity.sysvenueid;
        }
      this.loadData(1);
    },
      }
    }
  </script>
  <style scoped>
    @import '~@assets/less/common.less';
  </style>